import { Link, useLocation } from "@remix-run/react"

export function WaysToListen() {
  const location = useLocation()

  return (
    <div className="block secondary">
      {location.pathname == "/stations" ? (
        <h2>Other Ways to Listen</h2>
      ) : (
        <h2>Ways to Listen</h2>
      )}

      <div className="ways-to-listen-stacked">
        <Link
          className="daily-email"
          to="https://updates.ligonier.org/rym.html"
          target="_blank"
          rel="noreferrer"
          data-testid="listen-email"
        >
          Email
        </Link>
        <Link
          className="podcast"
          to="https://itunes.apple.com/us/podcast/renewing-your-mind-r.c.-sproul/id110916650?mt=2"
          target="_blank"
          rel="noreferrer"
          data-testid="listen-podcast-link"
        >
          Podcast
        </Link>
        <Link
          className="rss"
          to="https://renewingyourmind.ligonier.org/rss"
          target="_blank"
          rel="noreferrer"
          data-testid="listen-rss-link"
        >
          RSS
        </Link>
        {location.pathname != "/stations" ? (
          <Link
            className="radio"
            to="/stations"
            data-testid="listen-stations-link"
          >
            Radio
          </Link>
        ) : null}
        <Link
          className="refnet"
          to="http://onelink.to/refnet"
          target="_blank"
          rel="noreferrer"
          data-testid="listen-refnet-link"
        >
          RefNet
        </Link>
        <Link
          className="ligonier-app"
          to="http://onelink.to/ligonier"
          target="_blank"
          rel="noreferrer"
          data-testid="listen-ligonier-app-link"
        >
          Ligonier App
        </Link>
      </div>
    </div>
  )
}
